import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Tooltip from '@mui/material/Tooltip';


import { toast } from 'react-toastify';
import { AssetPaths, AppEnvironment, Constants } from './Constants';
import { IconButton } from '@mui/material';

export const toCurrencyFormat = function (value) {
	if (isNaN(value) || stringIsNullOrEmpty(value)) {
		const zero = 0;
		return zero.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
	}

	return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

//exports.formatCurrency = toCurrencyFormat;

export const formatNumber = function (value) {
	var number = toCurrencyFormat(value).replace(/\$/g, '');
	if (round(number, 2) == 0.00 || round(number, 2) == "-0.00") {
		number = '0.00';
	}
	return number;
}


//exports.formatNumber = toNumberFormat;

export const numberPatternFormat = function (value) {
	if (isNaN(value)) {
		return '0.00';
	}

	return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const toNumberWithNoDecimalPlaces = function (value) {
	if (isNaN(value)) {
		return '0';
	}

	return Number(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

//exports.formatAmount = toFormatAmount;

export const formatAmount = function (value) {
	if (value === null || value === undefined || value === '') return '0.00';

	const number = parseFloat(value);
	if (isNaN(number)) return '0.00';

	const formatted = number.toLocaleString('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return (formatted === '0.00' || formatted === '-0.00') ? '0.00' : formatted;
};


//exports.numberPatternFormat = toNumberPatternFormat;

export const truncateNumber = function (number) {
	const str = number.toString();
	const [integerPart, decimalPart] = str.split('.');

	if (integerPart.length > 9) {
		return integerPart.substring(0, 9) + '...';
	} else {
		return decimalPart ? integerPart + '.' + decimalPart : integerPart;
	}
}

//exports.truncateNumber = toTruncateNumber;

export const round = (number, decimalPlaces) => {
	const factorOfTen = Math.pow(10, decimalPlaces);
	return Math.round(number * factorOfTen) / factorOfTen;
}
export const isNullOrUndefined = function (value) {
	return value === undefined || value == null;
}

/*exports.isNullOrUndefined = isNullOrUndefined;*/

export const stringIsNullOrEmpty = function (value) {
	return value === undefined || value == null || (value != null && typeof value === "string" && value.length === 0);
}

//exports.stringIsNullOrEmpty = stringIsNullOrEmpty;

export const blankStringIfNullOrEmpty = function (value) {
	return value === undefined || value == null ? "" : value;
}

//exports.blankStringIfNullOrEmpty = blankStringIfNullOrEmpty;

export const defaultStringIfNullOrEmpty = function (value, defaultValue) {
	return stringIsNullOrEmpty(value) ? defaultValue : value;
}

//exports.defaultStringIfNullOrEmpty = defaultStringIfNullOrEmpty;

export const zeroIfNull = function (value) {

		return value === undefined || value == null || isNaN(value) ? 0 : value;	
}

//exports.zeroIfNull = zeroIfNull;

export const checkForUnAuthorizedException = function (compObj, error) {
	if (error.response.status === 401) {
		//let searchParams = new URLSearchParams(compObj.props.location.search);
		localStorage.removeItem("token");
		localStorage.removeItem("tokenExpiry");
		localStorage.removeItem("userInfo");
		localStorage.removeItem("authenticatedUser");
		document.location.href = "/logout";
		//compObj.props.history.push({
		//	pathname: "/login",
		//	//search: searchParams.toString()
		//});
	}
}

//exports.checkForUnAuthorizedException = checkForUnAuthorizedException;

export const addDaysInDate = function addDays(date, number) {
	const newDate = new Date(date);
	return new Date(newDate.setDate(newDate.getDate() + number));
}

//exports.addDaysInDate = addDaysInDate;


export const toDate = (date) => {
	//var hours = date.getHours();
	//var minutes = date.getMinutes();
	//var seconds = date.getSeconds();
	//var ampm = hours >= 12 ? 'PM' : 'AM';
	//hours = hours % 12;
	//hours = hours ? hours : 12;
	//minutes = minutes < 10 ? '0' + minutes : minutes;
	//seconds = seconds < 10 ? '0' + seconds : seconds;
	//var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
	return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear()
}

//exports.toDate = toDate;

export const formatDate =(date)=>{
	var hours = date.getHours();
	var minutes = date.getMinutes();
	var seconds = date.getSeconds();
	var ampm = hours >= 12 ? 'PM' : 'AM';
	hours = hours % 12;
	hours = hours ? hours : 12;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	seconds = seconds < 10 ? '0' + seconds : seconds;
	var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
	return (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear() + ",  " + strTime
}

//exports.formatDate = formatDate;

export const FormatToInputDate = (date) => {
	try {
		if (date) {
			let _date = new Date(date);
			let month = _date.getMonth() + 1;
			let day = _date.getDate();
			if (parseInt(day) < 10) { day = '0' + day }
			if (parseInt(month) < 10) { month = '0' + month }
			return (_date.getFullYear() + '-' + month + "-" + day);
		}
		else {
			return date;
		}
	}
	catch (ex) {
		return date;
	}
	
}

//exports.FormatToInputDate = FormatToInputDate;


export const objectClone = function skeleton(source, isArray) {
	var o = Array.isArray(source) ? [] : {};
	for (var key in source) {
		if (source.hasOwnProperty(key)) {
			var t = typeof source[key];
			o[key] = t == 'object' ? skeleton(source[key]) : { string: '', number: 0, boolean: false }[t];
		}
	}
	return o;
}
//exports.objectClone = objectClone;

export const uuid = function () {
	return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
		(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
	);
}
//exports.uuid = uuidv4;

export const dateParser = function (dateString) {
	const currentYear = new Date().getFullYear(); // Get current year

	// ISO 8601 format: YYYY-MM-DDTHH:MM:SS
	const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
	if (iso8601Regex.test(dateString)) {
		return new Date(dateString);
	}

	// Numeric formats
	const numericFormats = [
		{ regex: /^(\d{4})-(\d{2})-(\d{2})$/, format: 'YYYY-MM-DD' },
		{ regex: /^(\d{2})\/(\d{2})\/(\d{4})$/, format: 'MM/DD/YYYY' },
		{ regex: /^(\d{2})-(\d{2})-(\d{4})$/, format: 'MM-DD-YYYY' },
		{ regex: /^(\d{2})\/(\d{2})\/(\d{4})$/, format: 'DD/MM/YYYY' },
		{ regex: /^(\d{2})-(\d{2})-(\d{4})$/, format: 'DD-MM-YYYY' }
	];

	for (const { regex, format } of numericFormats) {
		const match = dateString.match(regex);
		if (match) {
			const [_, p1, p2, p3] = match;
			switch (format) {
				case 'YYYY-MM-DD':
					return new Date(p1, p2 - 1, p3);
				case 'MM/DD/YYYY':
				case 'MM-DD-YYYY':
					return new Date(p3, p1 - 1, p2);
				case 'DD/MM/YYYY':
				case 'DD-MM-YYYY':
					return new Date(p3, p2 - 1, p1);
			}
		}
	}

	// Textual month formats
	const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	const textualFormats = [
		{ regex: /^(\d{1,2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)$/, format: 'DD MMM' },
		{ regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{1,2})$/, format: 'MMM DD' }
	];

	for (const { regex, format } of textualFormats) {
		const match = dateString.match(regex);
		if (match) {
			const [_, p1, p2] = match;
			const monthIndex = monthNames.indexOf(p2);
			switch (format) {
				case 'DD MMM':
					return new Date(currentYear, monthIndex, p1);
				case 'MMM DD':
					return new Date(currentYear, monthIndex, p2);
			}
		}
	}

	// If no format matched
	return null;
};

export const getRoutingLevelOfApproval = function (modelDefId) {
	let invoiceRights = JSON.parse(localStorage?.userInfo || '');
	if (invoiceRights) {
		let invoiceUserRights = invoiceRights?.selectedUserRoles?.userRolesInvoiceRightsList
		if (invoiceUserRights) {
			let rights = invoiceUserRights.filter((e) => e.modelDefId === modelDefId);
			let routinglevel = 0;
			if (rights && rights.length > 0) {
				rights = rights[0];
				for (let i = 1; i < 6; i++) {
					if (rights[`isAllowInvoiceLevel${i}Approval`]) {
						routinglevel = i;
					}
				}

			}
			return routinglevel;
		}
		
	}
	return 0;
}
export const getDisplayName = (fieldName) => {
	const sysNames = JSON.parse(localStorage.getItem('sysNames') || '[]');
	const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');
	const companyCode = userInfo && userInfo.companyCode ? userInfo.companyCode : null;

	if (Array.isArray(sysNames) && companyCode !== null) {
		const sysName = sysNames.find(sn => sn.fieldName === fieldName && sn.companyCode === companyCode);
		return sysName ? sysName.displayName : fieldName;
	}
	return fieldName;
};


export const  downloadBase64File = (contentType, base64Data, fileName)=> {
	const linkSource = `data:${contentType};base64,${base64Data}`;
	const downloadLink = document.createElement("a");
	downloadLink.href = linkSource;
	downloadLink.download = fileName;
	downloadLink.click();
}
export const formatDateBySetting = (value, fieldFormat) => {
	if (!value) return value;
	if ((!fieldFormat || fieldFormat.trim() === "") && value.includes("T00:")) {
		return toDate(new Date(value));
	}
	else if (fieldFormat.trim() === "") {
		return value;
	}

	const date = new Date(value);
	if (isNaN(date.getTime())) return value;

	const formatMap = {
		"M d yyyy": { order: ["month", "day", "year"], separator: "/", options: { month: 'numeric', day: 'numeric', year: 'numeric' } },
		"M d yy": { order: ["month", "day", "year"], separator: "-", options: { month: 'numeric', day: 'numeric', year: '2-digit' } },
		"MMM d yyyy": { order: ["month", "day", "year"], separator: " ", options: { month: 'short', day: 'numeric', year: 'numeric' } },
		"MMM d yy": { order: ["month", "day", "year"], separator: ".", options: { month: 'short', day: 'numeric', year: '2-digit' } },
		"MMMM d yyyy": { order: ["month", "day", "year"], separator: "-", options: { month: 'long', day: 'numeric', year: 'numeric' } },
		"MMMM d yy": { order: ["month", "day", "year"], separator: " ", options: { month: 'long', day: 'numeric', year: '2-digit' } },
		"d M yyyy": { order: ["day", "month", "year"], separator: "-", options: { day: 'numeric', month: 'numeric', year: 'numeric' } },
		"d M yy": { order: ["day", "month", "year"], separator: ".", options: { day: 'numeric', month: 'numeric', year: '2-digit' } },
		"d MMM yyyy": { order: ["day", "month", "year"], separator: " ", options: { day: 'numeric', month: 'short', year: 'numeric' } },
		"d MMM yy": { order: ["day", "month", "year"], separator: "-", options: { day: 'numeric', month: 'short', year: '2-digit' } },
		"d MMMM yyyy": { order: ["day", "month", "year"], separator: " ", options: { day: 'numeric', month: 'long', year: 'numeric' } },
		"d MMMM yy": { order: ["day", "month", "year"], separator: "-", options: { day: 'numeric', month: 'long', year: '2-digit' } },
		"yyyy M d": { order: ["year", "month", "day"], separator: "-", options: { year: 'numeric', month: 'numeric', day: 'numeric' } },
		"yy M d": { order: ["year", "month", "day"], separator: " ", options: { year: '2-digit', month: 'numeric', day: 'numeric' } },
		"yyyy MMM d": { order: ["year", "month", "day"], separator: "-", options: { year: 'numeric', month: 'short', day: 'numeric' } },
		"yy MMM d": { order: ["year", "month", "day"], separator: "/", options: { year: '2-digit', month: 'short', day: 'numeric' } },
		"yyyy MMMM d": { order: ["year", "month", "day"], separator: " ", options: { year: 'numeric', month: 'long', day: 'numeric' } },
		"yy MMMM d": { order: ["year", "month", "day"], separator: ".", options: { year: '2-digit', month: 'long', day: 'numeric' } }
	};

	const formatInfo = formatMap[fieldFormat] || formatMap[""];
	if (!formatInfo) {
		return date.toLocaleDateString("en-US");
	}

	const formattedParts = new Intl.DateTimeFormat("en-US", formatInfo.options).formatToParts(date);
	const dateParts = {};
	formattedParts.forEach(part => {
		if (part.type !== 'literal') {
			dateParts[part.type] = part.value;
		}
	});

	return formatInfo.order.map(part => dateParts[part]).join(formatInfo.separator);
};

export const detectDateFormat = (value) => {
	if (!value) return null;

	const dateFormatPatterns = [
		// ISO 8601 Format
		{ regex: /^(\d{4})-(\d{1,2})-(\d{1,2})$/, format: "yyyy M d" }, // YYYY-MM-DD
		{ regex: /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/, format: "yyyy-MM-ddTHH:mm:ss" }, // YYYY-MM-DDTHH:mm:ss
		{ regex: /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})Z$/, format: "yyyy-MM-ddTHH:mm:ssZ" }, // YYYY-MM-DDTHH:mm:ssZ

		// MM/DD/YYYY and DD/MM/YYYY
		{ regex: /^(\d{1,2})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{4})$/, format: "M d yyyy" }, // 12/06/2019, 12-06-2019, etc.

		// DD Month YYYY (Full Month Name)
		{ regex: /^(\d{1,2})\s([A-Za-z]+)\s(\d{4})$/, format: "d MMMM yyyy" }, // 12 December 2019

		// DD Mon YYYY (Month Abbreviation)
		{ regex: /^(\d{1,2})\s([A-Za-z]{3})\s(\d{4})$/, format: "d MMM yyyy" }, // 12 Dec 2019

		// YYYYMMDD (Compact Format)
		{ regex: /^(\d{4})(\d{1,2})(\d{1,2})$/, format: "yyyyMMdd" }, // 20191206

		// Day, DD Month YYYY (Full Date with Day of the Week)
		{ regex: /^[A-Za-z]+,\s(\d{2})\s([A-Za-z]+)\s(\d{4})$/, format: "EEEE, d MMMM yyyy" }, // Tuesday, 12 December 2019

		// Month YYYY (Month/Year Only)
		{ regex: /^[A-Za-z]+\s(\d{4})$/, format: "MMMM yyyy" }, // December 2019

		// Numeric with dots and dashes
		{ regex: /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/, format: "d.M.yyyy" }, // 12.06.2019
		{ regex: /^(\d{1,2})-(\d{1,2})-(\d{4})$/, format: "d-M-yyyy" }, // 12-06-2019

		// YYYY/MM/DD
		{ regex: /^(\d{4})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{1,2})$/, format: "yyyy M d" }, // 2019/12/06

		// Month DD, YYYY
		{ regex: /^[A-Za-z]+\s(\d{1,2}),\s(\d{4})$/, format: "MMMM d, yyyy" }, // December 12, 2019

		// DD Month, YYYY
		{ regex: /^(\d{1,2})\s([A-Za-z]+),\s(\d{4})$/, format: "d MMMM, yyyy" }, // 12 December, 2019

		// Two-digit year (DD/MM/YY)
		{ regex: /^(\d{1,2})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{2})$/, format: "d M yy" }, // 12/06/19

		// MMM and MMMM with separators
		{ regex: /^([A-Za-z]{3,9})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{4})$/, format: "MMMM d yyyy" }, // Dec 12 2019
		{ regex: /^(\d{1,2})[\/\-\.\s]([A-Za-z]{3,9})[\/\-\.\s](\d{4})$/, format: "d MMMM yyyy" }, // 12 Dec 2019

		// Month abbreviation with period (Dec. 01, 2023)
		{ regex: /^([A-Za-z]{3})\.\s(\d{1,2}),\s(\d{4})$/, format: "MMM d, yyyy" }, // Dec. 12, 2019

		// Day first with period in month (01 Dec. 2023)
		{ regex: /^(\d{1,2})\s([A-Za-z]{3})\.,\s(\d{4})$/, format: "d MMM, yyyy" } // 12 Dec., 2019
	];

	for (const { regex, format } of dateFormatPatterns) {
		if (regex.test(value)) {
			return format;
		}
	}

	return null;
};


export const formatDateByIntelligence = (value, userSelectedFormat = null) => {
	if (value == null || (typeof value === 'string' && value.trim() === '') || typeof value !== 'string') {
		return userSelectedFormat || '';
	}

	const detectedFormat = detectDateFormat(value);

	const formatToUse = userSelectedFormat || detectedFormat || '';
	return formatToUse;
};

export const detectBillingPeriodFormat = (raw = "") => {
	if (!raw) return "M yy";

	let s = String(raw)
		.replace(/^[^:]*:\s*/, "")
		.replace(/\([^)]*\)/g, "")
		.replace(/[–—]+/g, "-")
		.replace(/[_\.]+/g, " ")
		.replace(/\s+/g, " ")
		.trim();

	const dateChunk =
		"(?:(?:\\d{1,2}[\\-/]\\d{1,2}[\\-/]\\d{2,4})|(?:\\d{4}[\\-/]\\d{1,2}[\\-/]\\d{1,2})|(?:\\d{1,2}[\\-/]\\s*[A-Za-z]{3,9}[\\-/]\\s*\\d{2,4})|(?:[A-Za-z]{3,9}\\.?\\s+\\d{1,2}(?:,?\\s*\\d{2,4})?)|(?:\\d{1,2}\\s+[A-Za-z]{3,9}\\.?\\s*\\d{2,4}))";

	const connector = "(?:\\bfrom\\b\\s+)?(?:to|through|thru|until|till|-)";

	const genericRange = new RegExp(`^\\s*${dateChunk}\\s*${connector}\\s*${dateChunk}\\s*$`, "i");
	if (genericRange.test(s)) return "Custom Range";

	const monthNameRange =
		/([A-Za-z]{3,9})\s+\d{1,2}(?:[, ]\s*\d{2,4})?\s*-\s*(?:[A-Za-z]{3,9}\s*)?\d{1,2}(?:[, ]\s*\d{2,4})?/i;
	if (monthNameRange.test(s)) return "Custom Range";

	if (/^[A-Za-z]{3,9}\s*[-\/\s]\s*\d{4}$/.test(s) || /^\d{1,2}\s+\d{4}$/.test(s)) return "M yyyy";
	if (/^\d{4}\s*[-\/\s]\s*[A-Za-z]{3,9}$/.test(s)) return "yyyy M";
	if (/^[A-Za-z]{3,9}\s*[-\/\s]\s*\d{2}$/.test(s)) return "M yy";
	if (/^\d{2}\s*[-\/\s]\s*[A-Za-z]{3,9}$/.test(s)) return "yy M";

	return "M yy";
};


export const convertToMySQLFormatCustom = (format) => {
	const dateFormatMap = {
		"M d yyyy": "%m %d %Y",
		"M d yy": "%m %d %y",
		"MMM d yyyy": "%b %d %Y",
		"MMM d yy": "%b %d %y",
		"MMMM d yyyy": "%M %d %Y",
		"MMMM d yy": "%M %d %y",
		"d M yyyy": "%d %m %Y",
		"d M yy": "%d %m %y",
		"d MMM yyyy": "%d %b %Y",
		"d MMM yy": "%d %b %y",
		"d MMMM yyyy": "%d %M %Y",
		"d MMMM yy": "%d %M %y",
		"yyyy M d": "%Y %m %d",
		"yy M d": "%y %m %d",
		"yyyy MMM d": "%Y %b %d",
		"yy MMM d": "%y %b %d",
		"yyyy MMMM d": "%Y %M %d",
		"yy MMMM d": "%y %M %d",
		"M yy": "%M %y %d",
		"M yyyy": "%b %Y %d", 
		"yy M": "%y %M %d",
		"yyyy M": "%Y %b %d" 
	};
	return dateFormatMap[format] || format; // Return original if no match
};

export const convertFromMySQLFormatCustom = (mysqlFormat) => {
	const dateFormatMap = {
		"%m %d %Y": "M d yyyy",
		"%m %d %y": "M d yy",
		"%b %d %Y": "MMM d yyyy",
		"%b %d %y": "MMM d yy",
		"%M %d %Y": "MMMM d yyyy",
		"%M %d %y": "MMMM d yy",
		"%d %m %Y": "d M yyyy",
		"%d %m %y": "d M yy",
		"%d %b %Y": "d MMM yyyy",
		"%d %b %y": "d MMM yy",
		"%d %M %Y": "d MMMM yyyy",
		"%d %M %y": "d MMMM yy",
		"%Y %m %d": "yyyy M d",
		"%y %m %d": "yy M d",
		"%Y %b %d": "yyyy MMM d",
		"%y %b %d": "yy MMM d",
		"%Y %M %d": "yyyy MMMM d",
		"%y %M %d": "yy MMMM d",
		"%M %y %d": "M yy",
		"%b %Y %d": "M yyyy",
		"%y %M %d": "yy M",
		"%Y %b %d": "yyyy M"
	};
	return dateFormatMap[mysqlFormat] || mysqlFormat; // Convert MySQL format to readable format
};

export const normalizeUiFormat = (s) => (s || "").toString().replace(/Y/g, "y").replace(/\s+/g, " ").trim();



export const calculateTax = (tax, invoiceAmount) => {
	if (invoiceAmount == 0) return 0;
	const isPrc = tax.prcFlag === 1;
	let calculatedTax = 0.00;
	let nonPrcAmount = tax.otherTaxAmt * !isPrc;
	if (tax.taxIncludedFlag == 1) {
		calculatedTax = (isPrc ? (parseFloat(invoiceAmount) * (tax.otherTaxAmt / 100) / (1 + (tax.otherTaxAmt / 100))) : 0) + nonPrcAmount;

	}
	else {
		calculatedTax = (isPrc ? (parseFloat(invoiceAmount) * (tax.otherTaxAmt / 100)) : 0) + nonPrcAmount;
	}
	return calculatedTax;
}

export const parseServiceTermDates = (serviceDateStr) => {
	if (!serviceDateStr || typeof serviceDateStr !== 'string') return { start: null, end: null };
	const [start, end] = serviceDateStr.split('-').map(s => s.trim());
	return { start, end };
}

export const formatDateMMDDYYYY = (value) => {
	if (!value) return null;

	const d = new Date(value);
	if (isNaN(d.getTime())) return null;

	const month = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	const year = d.getFullYear();

	return `${month}/${day}/${year}`;
};
//exports.calculateTax = calculateTax;


export const splitByUppercase = function(name){
	return name?.split(/(?=[A-Z])/)?.map(part => part.toLowerCase()) || [];
}


const STORAGE_KEY = "filterStorage";

export function initializeFilterStorage() {
	if (!localStorage.getItem(STORAGE_KEY)) {
		localStorage.setItem(STORAGE_KEY, JSON.stringify({}));
	}
}

export function setFilter(pathArray, value) {
	if (!Array.isArray(pathArray) || pathArray.length === 0) return;

	const data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};

	let current = data;
	for (let i = 0; i < pathArray.length - 1; i++) {
		const key = pathArray[i];
		if (!current[key] || typeof current[key] !== 'object') {
			current[key] = {};
		}
		current = current[key];
	}

	current[pathArray[pathArray.length - 1]] = value;
	localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}
export function getFilter(pathArray) {
	if (!Array.isArray(pathArray) || pathArray.length === 0) return null;

	const data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
	let current = data;

	for (let i = 0; i < pathArray.length; i++) {
		if (current[pathArray[i]] === undefined) return null;
		current = current[pathArray[i]];
	}

	return current;
}


export function getInvoiceModuleName(modelDefId) {

	switch (modelDefId) {
		case 1: return "MediaInvoices";
		case 2: return "ProductionInvoices";
		case 3: return "BroadcastInvoices";
		default: return "Invoices";
	}
}

export const getFileIcon = (fileName, style = {}) => {
	if (!fileName) return null;

	const ext = fileName.split('.').pop()?.toLowerCase();
	let path = '';

	if (ext === 'pdf') {
		path = AssetPaths.PDF_ICON;
	} else if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(ext)) {
		path = AssetPaths.PNG_ICON;
	}

	if (path) {
		return (
			<IconButton
				key={'file_icon_' + fileName}
				variant="contained"
				size="small"
				style={{
					zIndex: 1,
					marginLeft: '-8px',
					padding: '4px'
				}}
			>
				<img
					key={fileName + '_-icon'}
					src={path}
					alt="file-icon"
					style={{ width: 20, height: 20, ...style }}
				/>
			</IconButton>
		);
	}

	return (<></>);
};
//export function downloadInvoiceFile(
//	modelDefId,
//	invoiceDocumentId,
//	invoiceDocumentFileLocation
//) {
//	if (!invoiceDocumentFileLocation) {
//		return Promise.reject('Invalid file location');
//	}

//	return httpGet(
//		`/api/InvoiceDocument/scannedinvoicedocument/${modelDefId}/${invoiceDocumentId}/${invoiceDocumentFileLocation}`
//	).then((response) => {
//		const url = response.data?.documentUrl;
//		if (!url) {
//			throw new Error('File URL not found');
//		}

//		window.open(url, '_blank', 'noopener,noreferrer');
//	});
//}


export function downloadInvoiceFile(
	modelDefId,
	documentFileLocation,
	companyCode,
	mode
) {
	if (!documentFileLocation) {
		return Promise.reject('Invalid file location');
	}

	const encodedFileLocation = encodeURIComponent(documentFileLocation);

	let uri = `/api/InvoiceDocument/documenturl/${modelDefId}`;
	const queryParams = [`documentFileLocation=${encodedFileLocation}`];

	if (companyCode) {
		queryParams.push(`companyCode=${encodeURIComponent(companyCode)}`);
	}

	if (mode) {
		queryParams.push(`mode=${encodeURIComponent(mode)}`);
	}

	if (queryParams.length > 0) {
		uri += `?${queryParams.join('&')}`;
	}

	return httpGet(
		uri
	).then((response) => {
		const url = response?.data?.documentUrl;

		if (!url) {
			throw new Error('FILE_NOT_FOUND');
		}

		window.open(url, '_blank', 'noopener,noreferrer');
	});
}

export const PERIOD_ALIASES =
	["billing period",
	"invoice period",
	"Période de la facture",
	"période de facturation"];

export const isPeriodKey = (s) => {
	const str = String(s || "");
	return PERIOD_ALIASES.some(a => {
		const rx = new RegExp(`\\b${a.replace(/\s+/g, "\\s*")}\\b`, "i");
		return rx.test(str);
	});
};

export const isPeriodField = (mappedFields, field) =>
	(field === "serviceTermStartDate" || field === "serviceTermEndDate") &&
	isPeriodKey(mappedFields?.[field]?.mappedField);

export const findBillingPeriodKV = (keyValues = []) =>
	(keyValues || []).find(kv => isPeriodKey(kv?.Key));

export const getAppLogo = (appEnvironment) => {
	switch ((appEnvironment || '').toUpperCase()) {
		case AppEnvironment.Dev:
			return '/images/nexelus-logo-200_white.png';
		case AppEnvironment.Qa:
			return '/images/nexelus-logo-200_white.png';
		case AppEnvironment.Uat:
			return '/images/nexelus-logo-200_white_test.png';
		case AppEnvironment.Prod:
			return '/images/nexelus-logo-200_white.png';
		default:
			return '/images/nexelus-logo-200_white.png';
	}
};